export default __webpack_public_path__ + "dd1009f.png";